/* =============================================================================
   TINCTURESCU T3K — product.js
   Pagina de produs: galerie (crossfade desktop / derulare cu puncte pe mobil),
   oferte de cantitate calculate din preț × procent, sincronizarea cantității cu
   formularul și bara lipicioasă, distribuire, „ritualul complet” (adăugare multiplă)
   și recomandările Shopify cu rezervă. Folosește primitivele din app.js (window.T3K)
   dar nu cade dacă lipsesc.
   ============================================================================= */
(function () {
  'use strict';
  var D = document;
  function qs(s, r) { return (r || D).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function T() { return window.T3K || null; }
  function money(cents) {
    var t = T();
    if (t && typeof t.money === 'function') { try { return t.money(cents); } catch (e) { /* cade pe formatul simplu */ } }
    return (Math.round(cents) / 100).toFixed(2).replace('.', ',') + ' lei';
  }
  function toast(msg, kind) { var t = T(); if (t && t.toast) t.toast(msg, kind); }
  function reduced() {
    var t = T();
    if (t && typeof t.reduced === 'boolean') return t.reduced;
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
  var mobileMQ = window.matchMedia ? window.matchMedia('(max-width: 989px)') : { matches: false };

  /* ---------------------------------------------------------------------------
     1. GALERIE
     --------------------------------------------------------------------------- */
  function initGallery(section) {
    var gal = qs('[data-gallery]', section);
    if (!gal) return;
    var track = qs('[data-gallery-track]', gal);
    var slides = qsa('[data-gallery-slide]', gal);
    var thumbs = qsa('[data-gallery-thumb]', gal);
    var dots = qsa('[data-gallery-dot]', gal);
    var zoom = qs('[data-gallery-zoom]', gal);
    if (!slides.length) return;
    var cur = 0, scrollT = null;

    function paint(i) {
      cur = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (b, k) {
        b.classList.toggle('is-active', k === i);
        b.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (zoom) {
        var big = slides[i].getAttribute('data-lightbox');
        if (big) zoom.setAttribute('data-lightbox', big);
      }
      gal.setAttribute('data-gallery-index', String(i));
    }
    function go(i) {
      i = ((i % slides.length) + slides.length) % slides.length;
      if (mobileMQ.matches && track) {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduced() ? 'auto' : 'smooth' });
      }
      paint(i);
    }
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    if (track) {
      track.addEventListener('scroll', function () {
        if (!mobileMQ.matches) return;
        clearTimeout(scrollT);
        scrollT = setTimeout(function () {
          var w = Math.max(1, track.clientWidth);
          var i = clamp(Math.round(track.scrollLeft / w), 0, slides.length - 1);
          if (i !== cur) paint(i);
        }, 80);
      }, { passive: true });
    }
    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    /* La trecerea între ecrane, aliniem derularea cu imaginea activă */
    var onMQ = function () { go(cur); };
    if (mobileMQ.addEventListener) mobileMQ.addEventListener('change', onMQ);
    else if (mobileMQ.addListener) mobileMQ.addListener(onMQ);
    paint(0);
  }

  /* ---------------------------------------------------------------------------
     2. OFERTE + CANTITATE + TOTAL
     --------------------------------------------------------------------------- */
  function initBuy(section, price, t2, t3, bundle) {
    var qtyInput = qs('[data-qty-input]', section);
    var formQty = qs('[data-form-qty]', section);
    var offers = qsa('[data-offer-qty]', section);
    var btnTotal = qs('[data-btn-total]', section);
    var stickyAdd = qs('[data-sticky-add]', section);
    var stickyPrice = qs('[data-sticky-price]', section);
    var hint = qs('[data-offer-hint]', section);
    var form = qs('form[data-cart-add]', section);

    function pctFor(q) { if (!bundle) return 0; return q >= 3 ? t3 : (q === 2 ? t2 : 0); }
    function unit(q) { return Math.round(price * (100 - pctFor(q)) / 100); }
    function total(q) { return unit(q) * q; }

    /* Prețurile din tile-uri, calculate pe client din prețul variantei × procent */
    qsa('[data-offer-total]', section).forEach(function (el) {
      var q = parseInt(el.getAttribute('data-offer-total'), 10) || 1;
      if (price > 0) el.textContent = money(total(q));
    });
    qsa('[data-offer-unit]', section).forEach(function (el) {
      var q = parseInt(el.getAttribute('data-offer-unit'), 10) || 1;
      if (price > 0) el.textContent = money(unit(q));
    });

    function setQty(raw) {
      var q = clamp(parseInt(raw, 10) || 1, 1, 99);
      if (qtyInput && String(qtyInput.value) !== String(q)) qtyInput.value = q;
      if (formQty) formQty.value = q;
      if (stickyAdd) stickyAdd.setAttribute('data-quantity', String(q));
      if (price > 0) {
        var tot = total(q);
        if (btnTotal) btnTotal.textContent = money(tot);
        if (stickyPrice) stickyPrice.textContent = money(tot);
        if (hint) {
          var p = pctFor(q);
          hint.textContent = p ? ('Economisești ' + money(price * q - tot) + '.') : '';
        }
      }
      var tier = q >= 3 ? 3 : q;
      offers.forEach(function (r) {
        var on = (parseInt(r.value, 10) || 0) === tier;
        if (r.checked !== on) r.checked = on;
        var lab = r.closest('.offer');
        if (lab) lab.classList.toggle('is-active', on);
      });
    }

    offers.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) setQty(r.value); });
    });
    if (qtyInput) {
      ['input', 'change'].forEach(function (ev) {
        qtyInput.addEventListener(ev, function () { setQty(qtyInput.value); });
      });
      qtyInput.addEventListener('blur', function () { setQty(qtyInput.value); });
    }
    /* După adăugare, revenim la 1 sticlă ca următorul clic să nu dubleze din greșeală */
    if (form) form.addEventListener('t3k:added', function () { setQty(1); });
    setQty(qtyInput ? qtyInput.value : 1);
  }

  /* ---------------------------------------------------------------------------
     3. BARA LIPICIOASĂ (mobil) — apare când butonul principal a ieșit din ecran
     --------------------------------------------------------------------------- */
  function initSticky(section) {
    var bar = qs('[data-sticky-bar]', section);
    var anchor = qs('[data-buy-anchor]', section);
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var pastAnchor = false, footerVisible = false, dismissed = false;
    function show(on) {
      bar.classList.toggle('is-visible', on);
      D.body.classList.toggle('has-sticky-bar', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }
    function apply() { show(pastAnchor && !footerVisible && !dismissed); }
    /* Scroll-based check: an IntersectionObserver on the button misses a fast fling that jumps
       over it between two frames (the bar would then never appear). One rect read per frame. */
    var ticking = false;
    function checkAnchor() {
      ticking = false;
      pastAnchor = anchor.getBoundingClientRect().bottom < 0;
      apply();
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(checkAnchor); }
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(checkAnchor); }
    });
    checkAnchor();
    /* at the very end of the page the bar would only eat screen space: watch the footer's
       bottom bar (the whole footer is ~1400px tall on phones and would hide the bar too early) */
    var footerEnd = qs('.footer__bottom') || qs('.footer');
    if (footerEnd) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        apply();
      }, { threshold: 0 }).observe(footerEnd);
    }
    /* the customer can close it for this page view */
    var close = qs('[data-sticky-close]', bar);
    if (close) close.addEventListener('click', function () { dismissed = true; apply(); });
  }

  /* ---------------------------------------------------------------------------
     4. DISTRIBUIRE — copiere link + distribuire nativă (dacă există)
     --------------------------------------------------------------------------- */
  function copyFallback(url, done) {
    var i = D.createElement('input');
    i.value = url;
    i.setAttribute('readonly', '');
    i.style.position = 'fixed';
    i.style.opacity = '0';
    D.body.appendChild(i);
    i.select();
    var ok = false;
    try { ok = D.execCommand('copy'); } catch (e) { ok = false; }
    D.body.removeChild(i);
    if (ok) done(); else toast('Nu am putut copia linkul.', 'error');
  }
  function initShare(section) {
    qsa('[data-share-copy]', section).forEach(function (b) {
      b.addEventListener('click', function () {
        var url = b.getAttribute('data-url') || location.href;
        var done = function () {
          toast('Linkul a fost copiat.', 'ok');
          b.classList.add('is-success');
          setTimeout(function () { b.classList.remove('is-success'); }, 1400);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, function () { copyFallback(url, done); });
        } else {
          copyFallback(url, done);
        }
      });
    });
    qsa('[data-share-native]', section).forEach(function (b) {
      if (!navigator.share) { b.hidden = true; return; }
      b.hidden = false;
      b.addEventListener('click', function () {
        navigator.share({
          title: b.getAttribute('data-title') || D.title,
          url: b.getAttribute('data-url') || location.href
        }).catch(function () { /* anulat de utilizator */ });
      });
    });
  }

  /* ---------------------------------------------------------------------------
     5. RITUALUL COMPLET — tile-uri selectabile + data-cart-add-multi
     --------------------------------------------------------------------------- */
  function initRitual(section, t2, t3, bundle) {
    var wrap = qs('[data-ritual]', section);
    if (!wrap) return;
    var tiles = qsa('[data-ritual-tile]', wrap);
    var btn = qs('[data-ritual-add]', wrap);
    var countEl = qs('[data-ritual-count]', wrap);
    var totalEl = qs('[data-ritual-total]', wrap);
    var fullEl = qs('[data-ritual-full]', wrap);
    var saveEl = qs('[data-ritual-save]', wrap);
    function pct(n) { if (!bundle) return 0; return n >= 3 ? t3 : (n === 2 ? t2 : 0); }
    function update() {
      var items = [], full = 0;
      tiles.forEach(function (t) {
        if (!t.classList.contains('is-selected')) return;
        var id = parseInt(t.getAttribute('data-variant-id'), 10);
        if (!id) return;
        items.push({ id: id, quantity: 1 });
        full += parseInt(t.getAttribute('data-price'), 10) || 0;
      });
      var n = items.length, p = pct(n);
      var tot = Math.round(full * (100 - p) / 100);
      if (countEl) countEl.textContent = plural(n, 'sticlă', 'sticle');
      if (totalEl) totalEl.textContent = money(tot);
      if (fullEl) { fullEl.textContent = money(full); fullEl.hidden = !p; }
      if (saveEl) saveEl.textContent = p ? ('Economisești ' + money(full - tot) + ' (-' + p + '%)') : (bundle ? 'Alege încă o sticlă pentru reducere.' : '');
      if (btn) {
        btn.setAttribute('data-cart-add-multi', JSON.stringify(items));
        btn.disabled = n === 0;
        var l = qs('.btn__label', btn);
        if (l) l.textContent = n >= 2 ? 'Adaugă ritualul în coș' : 'Adaugă în coș';
      }
    }
    tiles.forEach(function (t) {
      if (t.hasAttribute('data-ritual-locked')) return;
      t.addEventListener('click', function () {
        var on = !t.classList.contains('is-selected');
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        update();
      });
    });
    update();
  }

  /* ---------------------------------------------------------------------------
     6. RECOMANDĂRI SHOPIFY — înlocuim rezerva doar dacă vin produse
     --------------------------------------------------------------------------- */
  function initRecs(section) {
    if (section.getAttribute('data-recs-inited') === '1') return;
    section.setAttribute('data-recs-inited', '1');
    var url = section.getAttribute('data-url');
    var holder = qs('[data-recommendations-content]', section);
    if (!url || !holder || !window.fetch || !window.DOMParser) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-recommendations-content]', doc);
        if (!fresh || !qs('.product-card', fresh)) return; /* rămâne rezerva din Liquid */
        holder.innerHTML = fresh.innerHTML;
        var t = T();
        if (t && t.init) t.init(section);
      })
      .catch(function () { /* rezerva rămâne pe loc */ });
  }

  /* ---------------------------------------------------------------------------
     7. INIȚIALIZARE (idempotentă; rulează și la shopify:section:load / t3k:init)
     --------------------------------------------------------------------------- */
  function initProduct(section) {
    if (section.getAttribute('data-product-inited') === '1') return;
    section.setAttribute('data-product-inited', '1');
    var price = parseInt(section.getAttribute('data-price') || '0', 10) || 0;
    var t2 = parseInt(section.getAttribute('data-tier2') || '0', 10) || 0;
    var t3 = parseInt(section.getAttribute('data-tier3') || '0', 10) || 0;
    var bundle = section.getAttribute('data-bundle') !== '0';
    initGallery(section);
    initBuy(section, price, t2, t3, bundle);
    initSticky(section);
    initShare(section);
    initRitual(section, t2, t3, bundle);
    var t = T();
    if (t && t.stripEmoji) qsa('.rte,[data-strip-emoji]', section).forEach(function (el) { t.stripEmoji(el); });
  }
  function collect(root, sel) {
    var list = [];
    if (root !== D && root.matches && root.matches(sel)) list.push(root);
    return list.concat(qsa(sel, root));
  }
  function initAll(scope) {
    var r = scope && scope.nodeType ? scope : D;
    collect(r, '[data-product-section]').forEach(initProduct);
    collect(r, '[data-recommendations]').forEach(initRecs);
  }
  D.addEventListener('t3k:init', function (e) { initAll(e.detail && e.detail.scope); });
  D.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { initAll(D); });
  else initAll(D);
})();
